<template>
  <div class="taskPages">
    <hr />
    <div class="pagesInfo">
      <strong>{{Pages.length}} Page(s)</strong>
    </div>
      <div v-for="Page in Pages" class="Page" :key="Page.id">
        <img class="img-fluid" :src="Page.photo" alt="Comment" />
        <h5 class="fw-semi-bold">{{Page.photoName}}</h5>
        <div class="pageButtons">
          {{Page.Name}}
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'TaskPages',
  props: ['Pages'],
};
</script>

<style src="./TaskPages.scss" lang="scss" scoped />
